import { render, staticRenderFns } from "./brandStying.vue?vue&type=template&id=233b588b&scoped=true"
import script from "./brandStying.js?vue&type=script&lang=js&external"
export * from "./brandStying.js?vue&type=script&lang=js&external"
import style0 from "./brandStying.vue?vue&type=style&index=0&id=233b588b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b588b",
  null
  
)

export default component.exports